import axios from 'axios';

export const getPermissions = locale => {
    return axios.get('/api/services/app/Session/GetPermissions', { params: { locale } });
};
